import styled from "styled-components";
import { Flex } from "../../../Flex/Flex.js";
import { ArrowUp02Linear } from "../../../Iconsax/ArrowUp02Linear.js";
import type { SidebarHookProps } from "../../Sidebar.types.js";

export type SidebarBrandPropsContainer = Pick<SidebarHookProps, "transitionState" | "transitionDuration">;

export const StyledBrandImage = styled.img`
    max-height: 100%;
    object-fit: contain;
    object-position: center;
    flex-shrink: 0;
    aspect-ratio: 1;
`;

export const StyledTitle = styled.img``;

export const StyledTitleWrapper = styled(Flex)``;

export const StyledSidebarBrandContainer = styled.div<SidebarBrandPropsContainer>`
    cursor: pointer;
    display: flex;
    align-items: center;
    /* justify-content: ${(props) => (props.transitionState !== "exited" ? "flex-start" : "center")}; */
    justify-content: flex-start;
    padding: 0 ${(props) => props.theme.spacing[12]};
    gap: ${(props) => props.theme.spacing[12]};

    > ${StyledBrandImage}, > ${StyledTitle} {
        height: ${(props) => props.theme.rem(1.25)};
        flex-shrink: 0;
    }

    > ${StyledTitleWrapper} {
        visibilty: ${({ transitionState }) => (transitionState === "exited" ? "hidden" : "visible")};
        opacity: ${({ transitionState }) => (transitionState === "entered" ? 1 : 0)};
        transition: opacity ${({ transitionDuration }) => transitionDuration * 0.75}ms
            ${({ transitionDuration, transitionState }) => (transitionState === "entered" ? transitionDuration * 0.25 : 0)}ms linear;
    }
`;

export const AnimatedIcon = styled(ArrowUp02Linear)<{ $isOpen: boolean }>`
    transform: rotate(${({ $isOpen }) => ($isOpen ? "0deg" : "180deg")});
    transition: transform 0.2s ease-in-out;
`;
